/**
 * menus/base.js
 * 모든 theme_type이 공유하는 내비게이션 원본 데이터.
 * SECTIONS · GROUPS · ITEMS · TABS 만 담는다 — SITEMAPS/MENUS 구성은 각 type 파일에서.
 */

// ---------------------------------------------------------------------------
// SECTIONS — 대분류
// ---------------------------------------------------------------------------

export const SECTIONS = {
    DIGITALS: {
        KEY: 'DIGITALS',
        NAME: '디지털인쇄',
        SHORTNAME: '디지털',
        LINK: '/all-digital-printing',
    },
    OFFSETS: {
        KEY: 'OFFSETS',
        NAME: '옵셋인쇄',
        SHORTNAME: '옵셋',
        LINK: '/all-offset-printing',
    },
    LARGEFORMATS: {
        KEY: 'LARGEFORMATS',
        NAME: '실사출력',
        SHORTNAME: '실사',
        LINK: '/all-largeformat-printing',
    },
    PHOTOFRAMES: {
        KEY: 'PHOTOFRAMES',
        NAME: '사진/액자',
        SHORTNAME: '사진',
        LINK: '/',
    },
    GOODS: {
        KEY: 'GOODS',
        NAME: '굿즈/기념품',
        SHORTNAME: '굿즈',
        LINK: '/',
    },
};

// ---------------------------------------------------------------------------
// GROUPS — 중분류
// ---------------------------------------------------------------------------

export const GROUPS = {
    // 디지털 ────────────────────────────────
    DIGITAL_BOOKLETS: {
        KEY: 'DIGITAL_BOOKLETS',
        SECTION: SECTIONS.DIGITALS,
        NAME: '디지털 책자',
        SHORTNAME: '책자',
        LINK: '/all-digital-printing#booklets',
    },
    DIGITAL_POSTERS: {
        KEY: 'DIGITAL_POSTERS',
        SECTION: SECTIONS.DIGITALS,
        NAME: '디지털 포스터',
        SHORTNAME: '포스터',
        LINK: '/all-digital-printing#posters',
    },
    DIGITAL_CATALOGS: {
        KEY: 'DIGITAL_CATALOGS',
        SECTION: SECTIONS.DIGITALS,
        NAME: '디지털 카탈로그',
        SHORTNAME: '카탈로그',
        LINK: '/all-digital-printing#catalogs',
    },
    DIGITAL_LEAFLETS: {
        KEY: 'DIGITAL_LEAFLETS',
        SECTION: SECTIONS.DIGITALS,
        NAME: '디지털 리플렛',
        SHORTNAME: '리플렛',
        LINK: '/all-digital-printing#leaflets',
    },
    DIGITAL_FLYERS: {
        KEY: 'DIGITAL_FLYERS',
        SECTION: SECTIONS.DIGITALS,
        NAME: '디지털 전단지',
        SHORTNAME: '전단지',
        LINK: '/all-digital-printing#flyers',
    },
    DIGITAL_INVITATIONS: {
        KEY: 'DIGITAL_INVITATIONS',
        SECTION: SECTIONS.DIGITALS,
        NAME: '디지털 초대장',
        SHORTNAME: '초대장',
        LINK: '/all-digital-printing#invitations',
    },
    DIGITAL_POSTCARDS: {
        KEY: 'DIGITAL_POSTCARDS',
        SECTION: SECTIONS.DIGITALS,
        NAME: '디지털 엽서',
        SHORTNAME: '엽서',
        LINK: '/all-digital-printing#postcards',
    },
    DIGITAL_BUSINESSCARDS: {
        KEY: 'DIGITAL_BUSINESSCARDS',
        SECTION: SECTIONS.DIGITALS,
        NAME: '디지털 명함',
        SHORTNAME: '명함',
        LINK: '/all-digital-printing#businesscards',
    },
    DIGITAL_CALENDARS: {
        KEY: 'DIGITAL_CALENDARS',
        SECTION: SECTIONS.DIGITALS,
        NAME: '디지털 캘린더',
        SHORTNAME: '캘린더',
        LINK: '/all-digital-printing#calendars',
    },
    DIGITAL_SHEETS: {
        KEY: 'DIGITAL_SHEETS',
        SECTION: SECTIONS.DIGITALS,
        NAME: '디지털 낱장인쇄',
        SHORTNAME: '낱장인쇄',
        LINK: '/all-digital-printing#sheets',
    },

    // 옵셋 ────────────────────────────────
    OFFSET_BOOKLETS: {
        KEY: 'OFFSET_BOOKLETS',
        SECTION: SECTIONS.OFFSETS,
        NAME: '옵셋 책자',
        SHORTNAME: '책자',
        LINK: '/all-offset-printing#booklets',
        VISIBLE: () => 123,
    },
    OFFSET_POSTERS: {
        KEY: 'OFFSET_POSTERS',
        SECTION: SECTIONS.OFFSETS,
        NAME: '옵셋 포스터',
        SHORTNAME: '포스터',
        LINK: '/all-offset-printing#posters',
        VISIBLE: () => 123,
    },
    OFFSET_CATALOGS: {
        KEY: 'OFFSET_CATALOGS',
        SECTION: SECTIONS.OFFSETS,
        NAME: '옵셋 카탈로그',
        SHORTNAME: '카탈로그',
        LINK: '/all-offset-printing#catalogs',
        VISIBLE: () => 123,
    },
    OFFSET_LEAFLETS: {
        KEY: 'OFFSET_LEAFLETS',
        SECTION: SECTIONS.OFFSETS,
        NAME: '옵셋 리플렛',
        SHORTNAME: '리플렛',
        LINK: '/all-offset-printing#leaflets',
        VISIBLE: () => 123,
    },
    OFFSET_FLYERS: {
        KEY: 'OFFSET_FLYERS',
        SECTION: SECTIONS.OFFSETS,
        NAME: '옵셋 전단지',
        SHORTNAME: '전단지',
        LINK: '/all-offset-printing#flyers',
        VISIBLE: () => 123,
    },
    OFFSET_INVITATIONS: {
        KEY: 'OFFSET_INVITATIONS',
        SECTION: SECTIONS.OFFSETS,
        NAME: '옵셋 초대장',
        SHORTNAME: '초대장',
        LINK: '/all-offset-printing#invitations',
        VISIBLE: () => 123,
    },
    OFFSET_POSTCARDS: {
        KEY: 'OFFSET_POSTCARDS',
        SECTION: SECTIONS.OFFSETS,
        NAME: '옵셋 엽서',
        SHORTNAME: '엽서',
        LINK: '/all-offset-printing#postcards',
        VISIBLE: () => 123,
    },
    OFFSET_BUSINESSCARDS: {
        KEY: 'OFFSET_BUSINESSCARDS',
        SECTION: SECTIONS.OFFSETS,
        NAME: '옵셋 명함',
        SHORTNAME: '명함',
        LINK: '/all-offset-printing#businesscards',
        VISIBLE: () => 123,
    },
    OFFSET_SHEETS: {
        KEY: 'OFFSET_SHEETS',
        SECTION: SECTIONS.OFFSETS,
        NAME: '옵셋 낱장인쇄',
        SHORTNAME: '낱장인쇄',
        LINK: '/all-offset-printing#sheets',
        VISIBLE: () => 123,
    },

    // 실사출력 ───────────────────────────────
    LARGEFORMAT_BANNERS: {
        KEY: 'LARGEFORMAT_BANNERS',
        SECTION: SECTIONS.LARGEFORMATS,
        NAME: '배너',
        SHORTNAME: '배너',
        LINK: '/all-largeformat-printing#banners',
    },
    LARGEFORMAT_HANGINGS: {
        KEY: 'LARGEFORMAT_HANGINGS',
        SECTION: SECTIONS.LARGEFORMATS,
        NAME: '현수막',
        SHORTNAME: '현수막',
        LINK: '/all-largeformat-printing#hangings',
    },
    LARGEFORMAT_PRINTINGS: {
        KEY: 'LARGEFORMAT_PRINTINGS',
        SECTION: SECTIONS.LARGEFORMATS,
        NAME: '실사출력',
        SHORTNAME: '실사',
        LINK: '/all-largeformat-printing#printings',
    },
};

// ---------------------------------------------------------------------------
// ITEMS — 상세항목 (leaf)
// ---------------------------------------------------------------------------

export const ITEMS = {
    // 디지털 책자 ──────────────────────────────
    DIGITAL_BOOKLET_WIRELESS: {
        KEY: 'DIGITAL_BOOKLET_WIRELESS',
        SECTION: SECTIONS.DIGITALS,
        GROUP: GROUPS.DIGITAL_BOOKLETS,
        LONGNAME: '디지털 무선책자',
        NAME: '무선책자',
        LINK: '/product/book-digital-wireless',
        ICON: null,
        PREVIEW: '/assets/img/dummyImgs/dummy0/0.png',
        BADGES: [],
        TAGS: ['빠른 제작', '소량인쇄', '고해상도', '합리적 가격'],
        KEYWORDS: ['떡제본', '풀제본', '단행본', '교재', '잡지', '논문', '보고서', '사보', '문집', '교본'],
        DESCRIPTION: null,
        VISIBLE: true,
    },
    DIGITAL_BOOKLET_STITCH: {
        KEY: 'DIGITAL_BOOKLET_STITCH',
        SECTION: SECTIONS.DIGITALS,
        GROUP: GROUPS.DIGITAL_BOOKLETS,
        LONGNAME: '디지털 중철책자',
        NAME: '중철책자',
        LINK: '/product/book-digital-stitch',
        ICON: null,
        PREVIEW: '/assets/img/dummyImgs/dummy0/1.png',
        BADGES: [],
        TAGS: ['빠른 제작', '소량인쇄', '우수한 펼침성', '경제적 가격'],
        KEYWORDS: ['스테이플', '잡지', '팜플렛', '소책자', '매거진', '뉴스레터', '사보', '가이드북', '안내책자', '프로그램북'],
        DESCRIPTION: null,
        VISIBLE: true,
    },
    DIGITAL_BOOKLET_TWINRING: {
        KEY: 'DIGITAL_BOOKLET_TWINRING',
        SECTION: SECTIONS.DIGITALS,
        GROUP: GROUPS.DIGITAL_BOOKLETS,
        LONGNAME: '디지털 트윈링책자',
        NAME: '트윈링책자',
        LINK: '/product/book-digital-twinring',
        ICON: null,
        PREVIEW: null,
        BADGES: [],
        TAGS: ['빠른 제작', '소량인쇄'],
        KEYWORDS: ['더블링', '와이어', '스프링', '다이어리', '플래너', '메뉴판', '교재', '매뉴얼', '수첩', '노트'],
        DESCRIPTION: null,
        VISIBLE: true,
    },
    DIGITAL_BOOKLET_COILRING: {
        KEY: 'DIGITAL_BOOKLET_COILRING',
        SECTION: SECTIONS.DIGITALS,
        GROUP: GROUPS.DIGITAL_BOOKLETS,
        LONGNAME: '디지털 코일링책자',
        NAME: '코일링책자',
        LINK: '/product/book-digital-coilring',
        ICON: null,
        PREVIEW: null,
        BADGES: [],
        TAGS: ['빠른 제작', '소량인쇄'],
        KEYWORDS: ['나선', '스프링', '노트', '교재', '연습장', '스케치북', '플래너', '메뉴판', '매뉴얼', '수첩'],
        DESCRIPTION: null,
        VISIBLE: true,
    },

    // 디지털 포스터 ────────────────────────────
    DIGITAL_POSTER_GENERAL: {
        KEY: 'DIGITAL_POSTER_GENERAL',
        SECTION: SECTIONS.DIGITALS,
        GROUP: GROUPS.DIGITAL_POSTERS,
        LONGNAME: '디지털 일반지 포스터',
        NAME: '일반지 포스터',
        LINK: '/product/poster-digital-general',
        ICON: null,
        PREVIEW: '/assets/img/dummyImgs/dummy1/0.png',
        BADGES: [],
        TAGS: ['빠른 제작', '소량인쇄', '고해상도', '합리적 가격'],
        KEYWORDS: ['벽보', '광고물', '게시물', '홍보', '행사', '공연', '전시', '안내문', '공고문', '부착물'],
        DESCRIPTION: null,
        VISIBLE: true,
    },
    DIGITAL_POSTER_PREMIUM: {
        KEY: 'DIGITAL_POSTER_PREMIUM',
        SECTION: SECTIONS.DIGITALS,
        GROUP: GROUPS.DIGITAL_POSTERS,
        LONGNAME: '디지털 고급지 포스터',
        NAME: '고급지 포스터',
        LINK: '/product/poster-digital-premium',
        ICON: null,
        PREVIEW: '/assets/img/dummyImgs/dummy1/1.png',
        BADGES: [],
        TAGS: ['빠른 제작', '소량인쇄', '우수한 펼침성', '경제적 가격'],
        KEYWORDS: ['아트지', '스노우지', '프리미엄', '갤러리', '전시회', '인테리어', '아트프린트', '액자', '작품', '고급'],
        DESCRIPTION: null,
        VISIBLE: true,
    },

    // 디지털 카탈로그 ────────────────────────────
    DIGITAL_CATALOG_WIRELESS: {
        KEY: 'DIGITAL_CATALOG_WIRELESS',
        SECTION: SECTIONS.DIGITALS,
        GROUP: GROUPS.DIGITAL_CATALOGS,
        LONGNAME: '디지털 무선 카탈로그',
        NAME: '무선 카탈로그',
        LINK: '/product/catalog-digital-wireless',
        ICON: null,
        PREVIEW: '/assets/img/dummyImgs/dummy2/0.png',
        BADGES: [],
        TAGS: ['빠른 제작', '소량인쇄', '고해상도', '합리적 가격'],
        KEYWORDS: ['브로슈어', '룩북', '회사소개서', '상품목록', '포트폴리오', '메뉴북', '가격표', '안내', '홍보', '제품소개'],
        DESCRIPTION: null,
        VISIBLE: true,
    },
    DIGITAL_CATALOG_STITCH: {
        KEY: 'DIGITAL_CATALOG_STITCH',
        SECTION: SECTIONS.DIGITALS,
        GROUP: GROUPS.DIGITAL_CATALOGS,
        LONGNAME: '디지털 중철 카탈로그',
        NAME: '중철 카탈로그',
        LINK: '/product/catalog-digital-stitch',
        ICON: null,
        PREVIEW: '/assets/img/dummyImgs/dummy2/1.png',
        BADGES: [],
        TAGS: ['빠른 제작', '소량인쇄', '우수한 펼침성', '경제적 가격'],
        KEYWORDS: ['브로슈어', '소책자', '매거진', '홍보', '팜플렛', '상품목록', '포트폴리오', '가이드북', '잡지', '제품소개'],
        DESCRIPTION: null,
        VISIBLE: true,
    },
    DIGITAL_CATALOG_TWINRING: {
        KEY: 'DIGITAL_CATALOG_TWINRING',
        SECTION: SECTIONS.DIGITALS,
        GROUP: GROUPS.DIGITAL_CATALOGS,
        LONGNAME: '디지털 트윈링 카탈로그',
        NAME: '트윈링 카탈로그',
        LINK: '/product/catalog-digital-twinring',
        ICON: null,
        PREVIEW: null,
        BADGES: [],
        TAGS: ['빠른 제작', '소량인쇄'],
        KEYWORDS: ['브로슈어', '스프링', '바인더', '메뉴판', '샘플북', '컬러차트', '스와치북', '교육자료', '매뉴얼', '제품소개'],
        DESCRIPTION: null,
        VISIBLE: true,
    },

    // 디지털 리플렛 ────────────────────────────
    DIGITAL_LEAFLET_GENERAL: {
        KEY: 'DIGITAL_LEAFLET_GENERAL',
        SECTION: SECTIONS.DIGITALS,
        GROUP: GROUPS.DIGITAL_LEAFLETS,
        LONGNAME: '디지털 일반지 리플렛',
        NAME: '일반지 리플렛',
        LINK: '/product/leaflet-digital-general',
        ICON: null,
        PREVIEW: '/assets/img/dummyImgs/dummy3/0.png',
        BADGES: [],
        TAGS: ['빠른 제작', '소량인쇄', '고해상도', '합리적 가격'],
        KEYWORDS: ['접지', '3단', '2단', '4단', '브로슈어', '안내문', '팜플렛', '홍보', '메뉴판', '가격표'],
        DESCRIPTION: null,
        VISIBLE: true,
    },
    DIGITAL_LEAFLET_PREMIUM: {
        KEY: 'DIGITAL_LEAFLET_PREMIUM',
        SECTION: SECTIONS.DIGITALS,
        GROUP: GROUPS.DIGITAL_LEAFLETS,
        LONGNAME: '디지털 고급지 리플렛',
        NAME: '고급지 리플렛',
        LINK: '/product/leaflet-digital-premium',
        ICON: null,
        PREVIEW: '/assets/img/dummyImgs/dummy3/1.png',
        BADGES: [],
        TAGS: ['빠른 제작', '소량인쇄', '우수한 펼침성', '경제적 가격'],
        KEYWORDS: ['접지', '아트지', '프리미엄', '스노우지', '코팅지', '브로슈어', '호텔', '관광', '고급', '안내문'],
        DESCRIPTION: null,
        VISIBLE: true,
    },

    // 디지털 전단지 ────────────────────────────
    DIGITAL_FLYER_GENERAL: {
        KEY: 'DIGITAL_FLYER_GENERAL',
        SECTION: SECTIONS.DIGITALS,
        GROUP: GROUPS.DIGITAL_FLYERS,
        LONGNAME: '디지털 일반지 전단지',
        NAME: '전단지',
        LINK: '/product/sheet-digital-normal',
        ICON: null,
        PREVIEW: '/assets/img/dummyImgs/dummy4/0.png',
        BADGES: [],
        TAGS: ['빠른 제작', '소량인쇄', '고해상도', '합리적 가격'],
        KEYWORDS: ['찌라시', '홍보', '광고지', '배포', '선전물', '삽지', '낱장', '이벤트', '오픈', '할인'],
        DESCRIPTION: null,
        VISIBLE: true,
    },

    // 디지털 초대장 ────────────────────────────
    DIGITAL_INVITATION: {
        KEY: 'DIGITAL_INVITATION',
        SECTION: SECTIONS.DIGITALS,
        GROUP: GROUPS.DIGITAL_INVITATIONS,
        LONGNAME: '디지털 초대장/안내장',
        NAME: '초대장/안내장',
        LINK: '/product/card-digital-visit',
        ICON: null,
        PREVIEW: '/assets/img/dummyImgs/dummy5/0.png',
        BADGES: [],
        TAGS: ['빠른 제작', '소량인쇄', '고해상도', '합리적 가격'],
        KEYWORDS: ['청첩장', '돌잔치', '웨딩', '개업', '송년회', '축하', '초청장', '행사', '모임', '기념식'],
        DESCRIPTION: null,
        VISIBLE: true,
    },
    DIGITAL_TICKET: {
        KEY: 'DIGITAL_TICKET',
        SECTION: SECTIONS.DIGITALS,
        GROUP: GROUPS.DIGITAL_INVITATIONS,
        LONGNAME: '디지털 상품권/티켓',
        NAME: '상품권/티켓',
        LINK: '/product/card-digital-ticket',
        ICON: null,
        PREVIEW: '/assets/img/dummyImgs/dummy5/1.png',
        BADGES: [],
        TAGS: ['빠른 제작', '소량인쇄', '우수한 펼침성', '경제적 가격'],
        KEYWORDS: ['입장권', '교환권', '이용권', '바우처', '기프트카드', '관람권', '식권', '주차권', '승차권', '이벤트'],
        DESCRIPTION: null,
        VISIBLE: true,
    },
    DIGITAL_COUPON: {
        KEY: 'DIGITAL_COUPON',
        SECTION: SECTIONS.DIGITALS,
        GROUP: GROUPS.DIGITAL_INVITATIONS,
        LONGNAME: '디지털 쿠폰',
        NAME: '쿠폰',
        LINK: '/product/card-digital-coupon',
        ICON: null,
        PREVIEW: null,
        BADGES: [],
        TAGS: ['빠른 제작', '소량인쇄'],
        KEYWORDS: ['할인', '교환', '이벤트', '프로모션', '적립', '무료체험', '사은품', '경품', '응모', '증정'],
        DESCRIPTION: null,
        VISIBLE: true,
    },

    // 디지털 엽서 ──────────────────────────────
    DIGITAL_POSTCARD: {
        KEY: 'DIGITAL_POSTCARD',
        SECTION: SECTIONS.DIGITALS,
        GROUP: GROUPS.DIGITAL_POSTCARDS,
        LONGNAME: '디지털 엽서',
        NAME: '엽서',
        LINK: '/product/card-digital-postcard',
        ICON: null,
        PREVIEW: '/assets/img/dummyImgs/dummy6/0.png',
        BADGES: [],
        TAGS: ['빠른 제작', '소량인쇄', '고해상도', '합리적 가격'],
        KEYWORDS: ['포스트카드', '감사', '기념', '인사장', '연하장', '크리스마스', '축하', '관광', '홍보', '사진'],
        DESCRIPTION: null,
        VISIBLE: true,
    },

    // 디지털 명함 ──────────────────────────────
    DIGITAL_BUSINESSCARD_GENERAL: {
        KEY: 'DIGITAL_BUSINESSCARD_GENERAL',
        SECTION: SECTIONS.DIGITALS,
        GROUP: GROUPS.DIGITAL_BUSINESSCARDS,
        LONGNAME: '디지털 일반지 명함',
        NAME: '일반지 명함',
        LINK: '/product/businesscard-digital-general',
        ICON: null,
        PREVIEW: '/assets/img/dummyImgs/dummy7/0.png',
        BADGES: [],
        TAGS: ['빠른 제작', '소량인쇄', '고해상도', '합리적 가격'],
        KEYWORDS: ['비즈니스카드', '네임카드', '회사', '직원', '개인', '소량', '양면', '컬러', '급행', '당일'],
        DESCRIPTION: null,
        VISIBLE: true,
    },
    DIGITAL_BUSINESSCARD_PREMIUM: {
        KEY: 'DIGITAL_BUSINESSCARD_PREMIUM',
        SECTION: SECTIONS.DIGITALS,
        GROUP: GROUPS.DIGITAL_BUSINESSCARDS,
        LONGNAME: '디지털 고급지 명함',
        NAME: '고급지 명함',
        LINK: '/product/businesscard-digital-premium',
        ICON: null,
        PREVIEW: '/assets/img/dummyImgs/dummy7/1.png',
        BADGES: [],
        TAGS: ['빠른 제작', '소량인쇄', '우수한 펼침성', '경제적 가격'],
        KEYWORDS: ['특수지', '엠보싱', '형압', '금박', '은박', '펄', '두꺼운', '디자인', '고급', '프리미엄'],
        DESCRIPTION: null,
        VISIBLE: true,
    },

    // 디지털 캘린더 ────────────────────────────
    DIGITAL_CALENDAR_DESKTOP_H: {
        KEY: 'DIGITAL_CALENDAR_DESKTOP_H',
        SECTION: SECTIONS.DIGITALS,
        GROUP: GROUPS.DIGITAL_CALENDARS,
        LONGNAME: '디지털 탁상용 캘린더(가로형)',
        NAME: '탁상용 캘린더(가로형)',
        LINK: '/product/calendar-digital-desktop',
        ICON: null,
        PREVIEW: '/assets/img/dummyImgs/dummy8/0.png',
        BADGES: [],
        TAGS: ['빠른 제작', '소량인쇄', '맞춤형 삼각대'],
        KEYWORDS: ['달력', '데스크', '책상', '사무실', '기업', '판촉', '홍보', '가로', '스탠드', '삼각대'],
        DESCRIPTION: null,
        VISIBLE: true,
    },
    DIGITAL_CALENDAR_DESKTOP_V: {
        KEY: 'DIGITAL_CALENDAR_DESKTOP_V',
        SECTION: SECTIONS.DIGITALS,
        GROUP: GROUPS.DIGITAL_CALENDARS,
        LONGNAME: '디지털 탁상용 캘린더(세로형)',
        NAME: '탁상용 캘린더(세로형)',
        LINK: '/product/calendar-digital-desktop2',
        ICON: null,
        PREVIEW: '/assets/img/dummyImgs/dummy8/1.png',
        BADGES: [],
        TAGS: ['빠른 제작', '소량인쇄', '맞춤형 삼각대'],
        KEYWORDS: ['달력', '데스크', '책상', '사무실', '기업', '판촉', '홍보', '세로', '스탠드', '삼각대'],
        DESCRIPTION: null,
        VISIBLE: true,
    },
    DIGITAL_CALENDAR_MINI: {
        KEY: 'DIGITAL_CALENDAR_MINI',
        SECTION: SECTIONS.DIGITALS,
        GROUP: GROUPS.DIGITAL_CALENDARS,
        LONGNAME: '디지털 미니 캘린더',
        NAME: '미니 캘린더',
        LINK: '/product/calendar-digital-desktop3',
        ICON: null,
        PREVIEW: null,
        BADGES: [],
        TAGS: ['빠른 제작', '소량인쇄'],
        KEYWORDS: ['달력', '포켓', '휴대용', '판촉', '사은품', '기념품', '소형', '탁상', '귀여운', '선물'],
        DESCRIPTION: null,
        VISIBLE: true,
    },
    DIGITAL_CALENDAR_WALLTYPE: {
        KEY: 'DIGITAL_CALENDAR_WALLTYPE',
        SECTION: SECTIONS.DIGITALS,
        GROUP: GROUPS.DIGITAL_CALENDARS,
        LONGNAME: '디지털 벽걸이용 캘린더',
        NAME: '벽걸이용 캘린더',
        LINK: '/product/calendar-digital-walltype',
        ICON: null,
        PREVIEW: null,
        BADGES: [],
        TAGS: ['빠른 제작', '대량인쇄', '브랜드가치', '경제적 가격'],
        KEYWORDS: ['달력', '벽', '월간', '대형', '부착', '기업', '홍보', '연간', '12장', '사무실'],
        DESCRIPTION: null,
        VISIBLE: true,
    },

    // 디지털 낱장인쇄 ────────────────────────────
    DIGITAL_SHEET: {
        KEY: 'DIGITAL_SHEET',
        SECTION: SECTIONS.DIGITALS,
        GROUP: GROUPS.DIGITAL_SHEETS,
        LONGNAME: '디지털 낱장인쇄',
        NAME: '낱장인쇄',
        LINK: '/product/single-sheet-digital-normal',
        ICON: null,
        PREVIEW: '/assets/img/dummyImgs/dummy9/0.png',
        BADGES: [],
        TAGS: ['빠른 제작', '소량인쇄', '고해상도', '합리적 가격'],
        KEYWORDS: ['단면', '양면', '복사', '출력', 'A4', 'A3', '서류', '문서', '컬러', '흑백'],
        DESCRIPTION: null,
        VISIBLE: true,
    },

    // 옵셋 책자 ──────────────────────────────
    OFFSET_BOOKLET_WIRELESS: {
        KEY: 'OFFSET_BOOKLET_WIRELESS',
        SECTION: SECTIONS.OFFSETS,
        GROUP: GROUPS.OFFSET_BOOKLETS,
        LONGNAME: '옵셋 무선책자',
        NAME: '무선책자',
        LINK: '/product/book-offset-wireless',
        ICON: null,
        PREVIEW: null,
        BADGES: [],
        TAGS: ['빠른 제작', '소량인쇄', '고해상도', '합리적 가격'],
        KEYWORDS: ['떡제본', '풀제본', '단행본', '교재', '잡지', '논문', '보고서', '사보', '문집', '교본'],
        DESCRIPTION: null,
        VISIBLE: () => 123,
    },
    OFFSET_BOOKLET_STITCH: {
        KEY: 'OFFSET_BOOKLET_STITCH',
        SECTION: SECTIONS.OFFSETS,
        GROUP: GROUPS.OFFSET_BOOKLETS,
        LONGNAME: '옵셋 중철책자',
        NAME: '중철책자',
        LINK: '/product/book-offset-stitch',
        ICON: null,
        PREVIEW: null,
        BADGES: [],
        TAGS: ['빠른 제작', '소량인쇄', '우수한 펼침성', '경제적 가격'],
        KEYWORDS: ['스테이플', '잡지', '팜플렛', '소책자', '매거진', '뉴스레터', '사보', '가이드북', '안내책자', '프로그램북'],
        DESCRIPTION: null,
        VISIBLE: () => 123,
    },
    OFFSET_BOOKLET_TWINRING: {
        KEY: 'OFFSET_BOOKLET_TWINRING',
        SECTION: SECTIONS.OFFSETS,
        GROUP: GROUPS.OFFSET_BOOKLETS,
        LONGNAME: '옵셋 트윈링책자',
        NAME: '트윈링책자',
        LINK: '/product/book-offset-twinring',
        ICON: null,
        PREVIEW: null,
        BADGES: [],
        TAGS: ['빠른 제작', '소량인쇄'],
        KEYWORDS: ['더블링', '와이어', '스프링', '다이어리', '플래너', '메뉴판', '교재', '매뉴얼', '수첩', '노트'],
        DESCRIPTION: null,
        VISIBLE: () => 123,
    },
    OFFSET_BOOKLET_COILRING: {
        KEY: 'OFFSET_BOOKLET_COILRING',
        SECTION: SECTIONS.OFFSETS,
        GROUP: GROUPS.OFFSET_BOOKLETS,
        LONGNAME: '옵셋 코일링책자',
        NAME: '코일링책자',
        LINK: '/product/book-offset-coilring',
        ICON: null,
        PREVIEW: null,
        BADGES: [],
        TAGS: ['빠른 제작', '소량인쇄'],
        KEYWORDS: ['나선', '스프링', '노트', '교재', '연습장', '스케치북', '플래너', '메뉴판', '매뉴얼', '수첩'],
        DESCRIPTION: null,
        VISIBLE: () => 123,
    },

    // 옵셋 포스터 ──────────────────────────────
    OFFSET_POSTER_GENERAL: {
        KEY: 'OFFSET_POSTER_GENERAL',
        SECTION: SECTIONS.OFFSETS,
        GROUP: GROUPS.OFFSET_POSTERS,
        LONGNAME: '옵셋 일반지 포스터',
        NAME: '일반지 포스터',
        LINK: '/product/sheet-poster-general',
        ICON: null,
        PREVIEW: null,
        BADGES: [],
        TAGS: ['빠른 제작', '소량인쇄', '고해상도', '합리적 가격'],
        KEYWORDS: ['벽보', '광고물', '게시물', '홍보', '행사', '공연', '전시', '안내문', '공고문', '부착물'],
        DESCRIPTION: null,
        VISIBLE: () => 123,
    },
    OFFSET_POSTER_PREMIUM: {
        KEY: 'OFFSET_POSTER_PREMIUM',
        SECTION: SECTIONS.OFFSETS,
        GROUP: GROUPS.OFFSET_POSTERS,
        LONGNAME: '옵셋 고급지 포스터',
        NAME: '고급지 포스터',
        LINK: '/product/sheet-poster-premium',
        ICON: null,
        PREVIEW: null,
        BADGES: [],
        TAGS: ['빠른 제작', '소량인쇄', '우수한 펼침성', '경제적 가격'],
        KEYWORDS: ['아트지', '스노우지', '프리미엄', '갤러리', '전시회', '인테리어', '아트프린트', '액자', '작품', '고급'],
        DESCRIPTION: null,
        VISIBLE: () => 123,
    },

    // 옵셋 카탈로그 ────────────────────────────
    OFFSET_CATALOG_WIRELESS: {
        KEY: 'OFFSET_CATALOG_WIRELESS',
        SECTION: SECTIONS.OFFSETS,
        GROUP: GROUPS.OFFSET_CATALOGS,
        LONGNAME: '옵셋 무선 카탈로그',
        NAME: '무선 카탈로그',
        LINK: '/product/catalog-offset-wireless',
        ICON: null,
        PREVIEW: null,
        BADGES: [],
        TAGS: ['빠른 제작', '소량인쇄', '고해상도', '합리적 가격'],
        KEYWORDS: ['브로슈어', '룩북', '회사소개서', '상품목록', '포트폴리오', '메뉴북', '가격표', '안내', '홍보', '제품소개'],
        DESCRIPTION: null,
        VISIBLE: () => 123,
    },
    OFFSET_CATALOG_STITCH: {
        KEY: 'OFFSET_CATALOG_STITCH',
        SECTION: SECTIONS.OFFSETS,
        GROUP: GROUPS.OFFSET_CATALOGS,
        LONGNAME: '옵셋 중철 카탈로그',
        NAME: '중철 카탈로그',
        LINK: '/product/catalog-offset-stitch',
        ICON: null,
        PREVIEW: null,
        BADGES: [],
        TAGS: ['빠른 제작', '소량인쇄', '우수한 펼침성', '경제적 가격'],
        KEYWORDS: ['브로슈어', '소책자', '매거진', '홍보', '팜플렛', '상품목록', '포트폴리오', '가이드북', '잡지', '제품소개'],
        DESCRIPTION: null,
        VISIBLE: () => 123,
    },
    OFFSET_CATALOG_TWINRING: {
        KEY: 'OFFSET_CATALOG_TWINRING',
        SECTION: SECTIONS.OFFSETS,
        GROUP: GROUPS.OFFSET_CATALOGS,
        LONGNAME: '옵셋 트윈링 카탈로그',
        NAME: '트윈링 카탈로그',
        LINK: '/product/catalog-offset-twinring',
        ICON: null,
        PREVIEW: null,
        BADGES: [],
        TAGS: ['빠른 제작', '소량인쇄'],
        KEYWORDS: ['브로슈어', '스프링', '바인더', '메뉴판', '샘플북', '컬러차트', '스와치북', '교육자료', '매뉴얼', '제품소개'],
        DESCRIPTION: null,
        VISIBLE: () => 123,
    },

    // 옵셋 리플렛 ──────────────────────────────
    OFFSET_LEAFLET_GENERAL: {
        KEY: 'OFFSET_LEAFLET_GENERAL',
        SECTION: SECTIONS.OFFSETS,
        GROUP: GROUPS.OFFSET_LEAFLETS,
        LONGNAME: '옵셋 일반지 리플렛',
        NAME: '일반지 리플렛',
        LINK: '/product/leaflet-offset-general',
        ICON: null,
        PREVIEW: null,
        BADGES: [],
        TAGS: ['빠른 제작', '소량인쇄', '고해상도', '합리적 가격'],
        KEYWORDS: ['접지', '3단', '2단', '4단', '브로슈어', '안내문', '팜플렛', '홍보', '메뉴판', '가격표'],
        DESCRIPTION: null,
        VISIBLE: () => 123,
    },
    OFFSET_LEAFLET_PREMIUM: {
        KEY: 'OFFSET_LEAFLET_PREMIUM',
        SECTION: SECTIONS.OFFSETS,
        GROUP: GROUPS.OFFSET_LEAFLETS,
        LONGNAME: '옵셋 고급지 리플렛',
        NAME: '고급지 리플렛',
        LINK: '/product/leaflet-offset-premium',
        ICON: null,
        PREVIEW: null,
        BADGES: [],
        TAGS: ['빠른 제작', '소량인쇄', '우수한 펼침성', '경제적 가격'],
        KEYWORDS: ['접지', '아트지', '프리미엄', '스노우지', '코팅지', '브로슈어', '호텔', '관광', '고급', '안내문'],
        DESCRIPTION: null,
        VISIBLE: () => 123,
    },

    // 옵셋 전단지 ──────────────────────────────
    OFFSET_FLYER_GENERAL: {
        KEY: 'OFFSET_FLYER_GENERAL',
        SECTION: SECTIONS.OFFSETS,
        GROUP: GROUPS.OFFSET_FLYERS,
        LONGNAME: '옵셋 전단지',
        NAME: '전단지',
        LINK: '/product/flyer-offset-general',
        ICON: null,
        PREVIEW: null,
        BADGES: [],
        TAGS: ['빠른 제작', '소량인쇄', '고해상도', '합리적 가격'],
        KEYWORDS: ['찌라시', '홍보', '광고지', '배포', '선전물', '삽지', '낱장', '이벤트', '오픈', '할인'],
        DESCRIPTION: null,
        VISIBLE: () => 123,
    },

    // 옵셋 초대장 ──────────────────────────────
    OFFSET_INVITATION_CARD: {
        KEY: 'OFFSET_INVITATION_CARD',
        SECTION: SECTIONS.OFFSETS,
        GROUP: GROUPS.OFFSET_INVITATIONS,
        LONGNAME: '옵셋 초대장/안내장',
        NAME: '초대장/안내장',
        LINK: '/product/card-offset-visit',
        ICON: null,
        PREVIEW: null,
        BADGES: [],
        TAGS: ['빠른 제작', '소량인쇄', '고해상도', '합리적 가격'],
        KEYWORDS: ['청첩장', '돌잔치', '웨딩', '개업', '송년회', '축하', '초청장', '행사', '모임', '기념식'],
        DESCRIPTION: null,
        VISIBLE: () => 123,
    },
    OFFSET_INVITATION_TICKET: {
        KEY: 'OFFSET_INVITATION_TICKET',
        SECTION: SECTIONS.OFFSETS,
        GROUP: GROUPS.OFFSET_INVITATIONS,
        LONGNAME: '옵셋 상품권/티켓',
        NAME: '상품권/티켓',
        LINK: '/product/card-offset-ticket',
        ICON: null,
        PREVIEW: null,
        BADGES: [],
        TAGS: ['빠른 제작', '소량인쇄'],
        KEYWORDS: ['입장권', '교환권', '이용권', '바우처', '기프트카드', '관람권', '식권', '주차권', '승차권', '이벤트'],
        DESCRIPTION: null,
        VISIBLE: () => 123,
    },
    OFFSET_INVITATION_COUPON: {
        KEY: 'OFFSET_INVITATION_COUPON',
        SECTION: SECTIONS.OFFSETS,
        GROUP: GROUPS.OFFSET_INVITATIONS,
        LONGNAME: '옵셋 쿠폰',
        NAME: '쿠폰',
        LINK: '/product/card-offset-coupon',
        ICON: null,
        PREVIEW: null,
        BADGES: [],
        TAGS: ['빠른 제작', '소량인쇄'],
        KEYWORDS: ['할인', '교환', '이벤트', '프로모션', '적립', '무료체험', '사은품', '경품', '응모', '증정'],
        DESCRIPTION: null,
        VISIBLE: () => 123,
    },

    // 옵셋 엽서 ──────────────────────────────
    OFFSET_POSTCARD: {
        KEY: 'OFFSET_POSTCARD',
        SECTION: SECTIONS.OFFSETS,
        GROUP: GROUPS.OFFSET_POSTCARDS,
        LONGNAME: '옵셋 엽서',
        NAME: '엽서',
        LINK: '/product/card-offset-postcard',
        ICON: null,
        PREVIEW: null,
        BADGES: [],
        TAGS: ['빠른 제작', '소량인쇄', '고해상도', '합리적 가격'],
        KEYWORDS: ['포스트카드', '감사', '기념', '인사장', '연하장', '크리스마스', '축하', '관광', '홍보', '사진'],
        DESCRIPTION: null,
        VISIBLE: () => 123,
    },

    // 옵셋 명함 ──────────────────────────────
    OFFSET_BUSINESSCARD_GENERAL: {
        KEY: 'OFFSET_BUSINESSCARD_GENERAL',
        SECTION: SECTIONS.OFFSETS,
        GROUP: GROUPS.OFFSET_BUSINESSCARDS,
        LONGNAME: '옵셋 일반지 명함',
        NAME: '일반지 명함',
        LINK: '/product/businesscard-offset-general',
        ICON: null,
        PREVIEW: null,
        BADGES: [],
        TAGS: ['빠른 제작', '소량인쇄', '고해상도', '합리적 가격'],
        KEYWORDS: ['비즈니스카드', '네임카드', '회사', '직원', '개인', '소량', '양면', '컬러', '급행', '당일'],
        DESCRIPTION: null,
        VISIBLE: () => 123,
    },
    OFFSET_BUSINESSCARD_PREMIUM: {
        KEY: 'OFFSET_BUSINESSCARD_PREMIUM',
        SECTION: SECTIONS.OFFSETS,
        GROUP: GROUPS.OFFSET_BUSINESSCARDS,
        LONGNAME: '옵셋 고급지 명함',
        NAME: '고급지 명함',
        LINK: '/product/businesscard-offset-premium',
        ICON: null,
        PREVIEW: null,
        BADGES: [],
        TAGS: ['빠른 제작', '소량인쇄', '우수한 펼침성', '경제적 가격'],
        KEYWORDS: ['특수지', '엠보싱', '형압', '금박', '은박', '펄', '두꺼운', '디자인', '고급', '프리미엄'],
        DESCRIPTION: null,
        VISIBLE: () => 123,
    },

    // 옵셋 낱장인쇄 ────────────────────────────
    OFFSET_SHEET: {
        KEY: 'OFFSET_SHEET',
        SECTION: SECTIONS.OFFSETS,
        GROUP: GROUPS.OFFSET_SHEETS,
        LONGNAME: '옵셋 낱장인쇄',
        NAME: '낱장인쇄',
        LINK: '/product/single-sheet-offset-normal',
        ICON: null,
        PREVIEW: null,
        BADGES: [],
        TAGS: ['빠른 제작', '소량인쇄', '고해상도', '합리적 가격'],
        KEYWORDS: ['단면', '양면', '복사', '출력', 'A4', 'A3', '서류', '문서', '컬러', '흑백'],
        DESCRIPTION: null,
        VISIBLE: () => 123,
    },

    // 실사출력 ───────────────────────────────
    LARGEFORMAT_BANNER_INDOOR: {
        KEY: 'LARGEFORMAT_BANNER_INDOOR',
        SECTION: SECTIONS.LARGEFORMATS,
        GROUP: GROUPS.LARGEFORMAT_BANNERS,
        LONGNAME: '실사출력 실내용 배너',
        NAME: '실내용 배너',
        LINK: '/product/stand-banner',
        ICON: null,
        PREVIEW: '/assets/img/dummyImgs/dummy10/0.png',
        BADGES: [],
        TAGS: ['빠른 제작', '소량인쇄', '고해상도', '합리적 가격'],
        KEYWORDS: ['X배너', '스탠드', '롤업', '거치대', '행사', '전시', '매장', '안내', 'Y배너', '이젤'],
        DESCRIPTION: null,
        VISIBLE: true,
    },
    LARGEFORMAT_BANNER_OUTDOOR: {
        KEY: 'LARGEFORMAT_BANNER_OUTDOOR',
        SECTION: SECTIONS.LARGEFORMATS,
        GROUP: GROUPS.LARGEFORMAT_BANNERS,
        LONGNAME: '실사출력 실외용 배너',
        NAME: '실외용 배너',
        LINK: '/product/outdoor-banner',
        ICON: null,
        PREVIEW: null,
        BADGES: [],
        TAGS: ['빠른 제작', '소량인쇄', '고해상도', '합리적 가격'],
        KEYWORDS: ['야외', '옥외광고', '간판', '현장', '방수', '외부', '공사', '축제', '행사장', '야외행사'],
        DESCRIPTION: null,
        VISIBLE: true,
    },
    LARGEFORMAT_BANNER_MINI: {
        KEY: 'LARGEFORMAT_BANNER_MINI',
        SECTION: SECTIONS.LARGEFORMATS,
        GROUP: GROUPS.LARGEFORMAT_BANNERS,
        LONGNAME: '실사출력 미니 배너',
        NAME: '미니 배너',
        LINK: '/product/mini-banner',
        ICON: null,
        PREVIEW: null,
        BADGES: [],
        TAGS: ['빠른 제작', '소량인쇄'],
        KEYWORDS: ['탁상', '소형', '테이블', 'POP', '카운터', '접수대', '안내데스크', '미니거치대', '매장'],
        DESCRIPTION: null,
        VISIBLE: true,
    },
    LARGEFORMAT_HANGING: {
        KEY: 'LARGEFORMAT_HANGING',
        SECTION: SECTIONS.LARGEFORMATS,
        GROUP: GROUPS.LARGEFORMAT_HANGINGS,
        LONGNAME: '실사출력 현수막',
        NAME: '현수막',
        LINK: '/product/largeformat-hanging-general',
        ICON: null,
        PREVIEW: '/assets/img/dummyImgs/dummy10/1.png',
        BADGES: [],
        TAGS: ['빠른 제작', '고해상도', '경제적 가격'],
        KEYWORDS: ['플래카드', '행사', '축하', '개업', '선거', '축제', '체육대회', '졸업', '환영'],
        DESCRIPTION: null,
        VISIBLE: true,
    },
    LARGEFORMAT_PRINTING: {
        KEY: 'LARGEFORMAT_PRINTING',
        SECTION: SECTIONS.LARGEFORMATS,
        GROUP: GROUPS.LARGEFORMAT_PRINTINGS,
        LONGNAME: '실사출력',
        NAME: '실사출력',
        LINK: '/product/largeformat-printing-general',
        ICON: null,
        PREVIEW: null,
        BADGES: [],
        TAGS: ['빠른 제작', '대형출력', '고해상도'],
        KEYWORDS: ['대형', '와이드', '포맥스', '시트지', '벽면', '래핑', '차량', '유리', '인테리어', '사인물'],
        DESCRIPTION: null,
        VISIBLE: true,
    },
};

// ---------------------------------------------------------------------------
// TABS — 아이템 묶음 (type: 'tab' | 'standalone')
//
//   tab        → 탭 제목(NAME) + 아이템 리스트 표시
//   standalone → 탭 없이 아이템 리스트만 표시
// ---------------------------------------------------------------------------

export const TABS = {
    // 디지털 책자 ────────────────────────────
    MAKE_A_BOOK: {
        KEY: 'MAKE_A_BOOK',
        TYPE: 'tab',
        NAME: '나만의 책',
        ITEMS: [ITEMS.DIGITAL_BOOKLET_WIRELESS, ITEMS.DIGITAL_BOOKLET_STITCH, ITEMS.DIGITAL_BOOKLET_TWINRING, ITEMS.DIGITAL_BOOKLET_COILRING],
    },
    WITH_SPRINGS: {
        KEY: 'WITH_SPRINGS',
        TYPE: 'tab',
        NAME: '스프링이 필요해',
        ITEMS: [ITEMS.DIGITAL_BOOKLET_TWINRING, ITEMS.DIGITAL_BOOKLET_COILRING],
    },
    WITH_MAGAZINES: {
        KEY: 'WITH_MAGAZINES',
        TYPE: 'tab',
        NAME: '교재/잡지로 딱!',
        ITEMS: [ITEMS.DIGITAL_BOOKLET_WIRELESS, ITEMS.DIGITAL_BOOKLET_STITCH],
    },

    // 디지털 포스터 ────────────────────────────
    DIGITAL_POSTERS_STANDALONE: {
        KEY: 'DIGITAL_POSTERS_STANDALONE',
        TYPE: 'standalone',
        NAME: null,
        ITEMS: [ITEMS.DIGITAL_POSTER_GENERAL, ITEMS.DIGITAL_POSTER_PREMIUM],
    },

    // 디지털 카탈로그 ────────────────────────────
    DIGITAL_CATALOGS_STANDALONE: {
        KEY: 'DIGITAL_CATALOGS_STANDALONE',
        TYPE: 'standalone',
        NAME: null,
        ITEMS: [ITEMS.DIGITAL_CATALOG_WIRELESS, ITEMS.DIGITAL_CATALOG_STITCH, ITEMS.DIGITAL_CATALOG_TWINRING],
    },

    // 디지털 리플렛 ────────────────────────────
    DIGITAL_LEAFLETS_STANDALONE: {
        KEY: 'DIGITAL_LEAFLETS_STANDALONE',
        TYPE: 'standalone',
        NAME: null,
        ITEMS: [ITEMS.DIGITAL_LEAFLET_GENERAL, ITEMS.DIGITAL_LEAFLET_PREMIUM],
    },

    // 디지털 전단지 ────────────────────────────
    DIGITAL_FLYERS_STANDALONE: {
        KEY: 'DIGITAL_FLYERS_STANDALONE',
        TYPE: 'standalone',
        NAME: null,
        ITEMS: [ITEMS.DIGITAL_FLYER_GENERAL],
    },

    // 디지털 초대장 ────────────────────────────
    DIGITAL_INVITATIONS_STANDALONE: {
        KEY: 'DIGITAL_INVITATIONS_STANDALONE',
        TYPE: 'standalone',
        NAME: null,
        ITEMS: [ITEMS.DIGITAL_INVITATION, ITEMS.DIGITAL_TICKET, ITEMS.DIGITAL_COUPON],
    },

    // 디지털 엽서 ──────────────────────────────
    DIGITAL_POSTCARDS_STANDALONE: {
        KEY: 'DIGITAL_POSTCARDS_STANDALONE',
        TYPE: 'standalone',
        NAME: null,
        ITEMS: [ITEMS.DIGITAL_POSTCARD],
    },

    // 디지털 명함 ──────────────────────────────
    DIGITAL_BUSINESSCARDS_STANDALONE: {
        KEY: 'DIGITAL_BUSINESSCARDS_STANDALONE',
        TYPE: 'standalone',
        NAME: null,
        ITEMS: [ITEMS.DIGITAL_BUSINESSCARD_GENERAL, ITEMS.DIGITAL_BUSINESSCARD_PREMIUM],
    },

    // 디지털 캘린더 ────────────────────────────
    DIGITAL_CALENDARS_DESKTOPTYPES: {
        KEY: 'DIGITAL_CALENDARS_DESKTOPTYPES',
        TYPE: 'tab',
        NAME: '올려놓고 쓰는',
        ITEMS: [ITEMS.DIGITAL_CALENDAR_DESKTOP_H, ITEMS.DIGITAL_CALENDAR_DESKTOP_V, ITEMS.DIGITAL_CALENDAR_MINI],
    },
    DIGITAL_CALENDARS_WALLTYPE: {
        KEY: 'DIGITAL_CALENDARS_WALLTYPE',
        TYPE: 'tab',
        NAME: '걸어두고 쓰는',
        ITEMS: [ITEMS.DIGITAL_CALENDAR_WALLTYPE],
    },

    // 디지털 낱장인쇄 ────────────────────────────
    DIGITAL_SHEETS_STANDALONE: {
        KEY: 'DIGITAL_SHEETS_STANDALONE',
        TYPE: 'standalone',
        NAME: null,
        ITEMS: [ITEMS.DIGITAL_SHEET],
    },

    // 옵셋 책자 ──────────────────────────────
    OFFSET_BOOKLETS_STANDALONE: {
        KEY: 'OFFSET_BOOKLETS_STANDALONE',
        TYPE: 'standalone',
        NAME: null,
        ITEMS: [ITEMS.OFFSET_BOOKLET_WIRELESS, ITEMS.OFFSET_BOOKLET_STITCH, ITEMS.OFFSET_BOOKLET_TWINRING, ITEMS.OFFSET_BOOKLET_COILRING],
    },

    // 옵셋 포스터 ──────────────────────────────
    OFFSET_POSTERS_STANDALONE: {
        KEY: 'OFFSET_POSTERS_STANDALONE',
        TYPE: 'standalone',
        NAME: null,
        ITEMS: [ITEMS.OFFSET_POSTER_GENERAL, ITEMS.OFFSET_POSTER_PREMIUM],
    },

    // 옵셋 카탈로그 ────────────────────────────
    OFFSET_CATALOGS_STANDALONE: {
        KEY: 'OFFSET_CATALOGS_STANDALONE',
        TYPE: 'standalone',
        NAME: null,
        ITEMS: [ITEMS.OFFSET_CATALOG_WIRELESS, ITEMS.OFFSET_CATALOG_STITCH, ITEMS.OFFSET_CATALOG_TWINRING],
    },

    // 옵셋 리플렛 ──────────────────────────────
    OFFSET_LEAFLETS_STANDALONE: {
        KEY: 'OFFSET_LEAFLETS_STANDALONE',
        TYPE: 'standalone',
        NAME: null,
        ITEMS: [ITEMS.OFFSET_LEAFLET_GENERAL, ITEMS.OFFSET_LEAFLET_PREMIUM],
    },

    // 옵셋 전단지 ──────────────────────────────
    OFFSET_FLYERS_STANDALONE: {
        KEY: 'OFFSET_FLYERS_STANDALONE',
        TYPE: 'standalone',
        NAME: null,
        ITEMS: [ITEMS.OFFSET_FLYER_GENERAL],
    },

    // 옵셋 초대장 ──────────────────────────────
    OFFSET_INVITATIONS_STANDALONE: {
        KEY: 'OFFSET_INVITATIONS_STANDALONE',
        TYPE: 'standalone',
        NAME: null,
        ITEMS: [ITEMS.OFFSET_INVITATION_CARD, ITEMS.OFFSET_INVITATION_TICKET, ITEMS.OFFSET_INVITATION_COUPON],
    },

    // 옵셋 엽서 ──────────────────────────────
    OFFSET_POSTCARDS_STANDALONE: {
        KEY: 'OFFSET_POSTCARDS_STANDALONE',
        TYPE: 'standalone',
        NAME: null,
        ITEMS: [ITEMS.OFFSET_POSTCARD],
    },

    // 옵셋 명함 ──────────────────────────────
    OFFSET_BUSINESSCARDS_STANDALONE: {
        KEY: 'OFFSET_BUSINESSCARDS_STANDALONE',
        TYPE: 'standalone',
        NAME: null,
        ITEMS: [ITEMS.OFFSET_BUSINESSCARD_GENERAL, ITEMS.OFFSET_BUSINESSCARD_PREMIUM],
    },

    // 옵셋 낱장인쇄 ────────────────────────────
    OFFSET_SHEETS_STANDALONE: {
        KEY: 'OFFSET_SHEETS_STANDALONE',
        TYPE: 'standalone',
        NAME: null,
        ITEMS: [ITEMS.OFFSET_SHEET],
    },

    // 실사출력 배너 ────────────────────────────
    LARGEFORMAT_BANNERS_STANDALONE: {
        KEY: 'LARGEFORMAT_BANNERS_STANDALONE',
        TYPE: 'standalone',
        NAME: null,
        ITEMS: [ITEMS.LARGEFORMAT_BANNER_INDOOR, ITEMS.LARGEFORMAT_BANNER_OUTDOOR, ITEMS.LARGEFORMAT_BANNER_MINI],
    },

    // 실사출력 현수막 ────────────────────────────
    LARGEFORMAT_HANGINGS_STANDALONE: {
        KEY: 'LARGEFORMAT_HANGINGS_STANDALONE',
        TYPE: 'standalone',
        NAME: null,
        ITEMS: [ITEMS.LARGEFORMAT_HANGING],
    },

    // 실사출력 낱장 ────────────────────────────
    LARGEFORMAT_PRINTINGS_STANDALONE: {
        KEY: 'LARGEFORMAT_PRINTINGS_STANDALONE',
        TYPE: 'standalone',
        NAME: null,
        ITEMS: [ITEMS.LARGEFORMAT_PRINTING],
    },
};

// ---------------------------------------------------------------------------
// Helpers
// ---------------------------------------------------------------------------

export function isVisible(visible) {
    if (visible === undefined || visible === null) return true;
    if (typeof visible === 'function') return !!visible();
    return !!visible;
}

export function getItemsByGroup(groupKey) {
    return Object.values(ITEMS).filter((item) => item.GROUP.KEY === groupKey);
}

export function getItemsBySection(sectionKey) {
    return Object.values(ITEMS).filter((item) => item.SECTION.KEY === sectionKey);
}
